import styled from 'styled-components';

export const LegendsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 auto;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendCircle = styled.div<{ color: string }>`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

export const LegendText = styled.span``;
